<p-toolbar>
    <ng-template #start>
        <h3 class="p-toolbar-title">Active Shipments</h3>
    </ng-template>
    <ng-template #end>
        <p-button icon="pi pi-qrcode" [rounded]="true" [text]="true" (onClick)="this.isCameraOpen = true" />
    </ng-template>
</p-toolbar>

<tgcs-qr-scanner #qrScanner *ngIf="isCameraOpen" (closeCamera)="isCameraOpen = false" (qrCodeCaptured)="qrCodeCaptured($event) " ></tgcs-qr-scanner>

<div *ngIf="shipmentList().length > 0" class="active-shipment-container">
     <p-iconfield>
        <p-inputicon class="pi pi-search" />
        <input class="search-input" type="text"  [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
               pInputText placeholder="Search Shipment"  pSize="large"  />
    </p-iconfield>

    <div class="status-filter-container">
        <p-selectButton [options]="statusList()"  [(ngModel)]="selectedStatus" (ngModelChange)="selectedStatus.set($event)"  optionLabel="status" optionValue="status" />
    </div>

    @for (item of shimentListFilter(); track item.id) {
        
        <div class="shimpent-card-container">
            <p-card >
                <ng-template #header>
                    <div class="shipment-card-header">
                        <div class="shipment-id-container">
                            <p class="shipment-id-title">SHIPMENT ID</p>
                            <p class="shipment-id-value-title">{{item.uploadId}}</p>
                        </div>
                        <div class="shipment-status-container">
                            <p-chip [label]="'• ' + item.deliveryStatus.status" />
                        </div>
                    </div>
                </ng-template>

                <!--<ng-template #title> Advanced Card </ng-template>
                <ng-template #subtitle> Card subtitle </ng-template>-->
                <div class="card-content">
                    <i class="pi pi-truck" style="color: var(--p-primary-color); font-size: 1.2rem;"></i>
                    <div class="card-content-details">
                        <p class="pickup-title">Pickup</p>
                        <p class="pickup-value">{{item.createdDate | date:'short'}}</p>
                    </div>

                </div>
                <ng-template #footer>
                    <p-button (onClick)="openDetails(item)" class="view-detail-button" label="View Details" icon="pi pi-angle-right" iconPos="right"/>
                </ng-template>
            </p-card>
        </div>



    }

</div>
